import { FC } from "react";

const SVGIconFocusmode:FC = () => {
    return(
        <svg width="24px" height="24px" viewBox="0,0,256,256"><g><g transform="scale(5.12,5.12)"><path d="M25.5625,47c-12.44141,0 -22.5625,-10.12109 -22.5625,-22.5625c0,-9.65625 6.30469,-18.25 15.68359,-21.38672c0.41406,-0.13672 0.86719,0.00781 1.12109,0.35547c0.25781,0.35156 0.26172,0.82813 0.00781,1.17969c-1.72656,2.39063 -3.78125,6.21094 -3.78125,10.82813c0,10.23047 8.32422,18.55469 18.55859,18.55469c4.61719,0 8.4375,-2.05469 10.82422,-3.77734c0.35547,-0.25391 0.82813,-0.25391 1.17969,0.00391c0.35156,0.25781 0.49219,0.71094 0.35547,1.12109c-3.13672,9.37891 -11.73047,15.68359 -21.38672,15.68359z"></path></g></g></svg>
    );
}

export default SVGIconFocusmode;